var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock"},[_c('label',{staticClass:"hour"},[_vm._v(_vm._s(_vm.$date(_vm.currentTime).format('HH')))]),_c('label',{staticClass:"ticker"},[_vm._v(":")]),_c('label',{staticClass:"minutes"},[_vm._v(_vm._s(_vm.$date(_vm.currentTime).format('mm')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }